import { Icon } from 'common/icon';
import { Breadcrumbs } from 'components/bredcrambs';
import { Layout } from 'components/layout';
import { CustomMetadata } from 'components/metadata';
import { Anchor } from 'constants/anchors';
import { allMetadata } from 'constants/metadata';
import { streamerPage } from 'constants/routes-breadcrumbs';
import {
  ICasinoReviewGraph,
  INavItem,
  IStreamer,
  IStreamerReview,
} from 'constants/types';
import dynamic from 'next/dynamic';
import { Description } from 'components/description';
import { StreamerHeader } from './streamer-header';
import styles from './styles.module.css';

const NavigationBarSection = dynamic(
  () => import('../casino/casino-navigations').then((mod) => mod.NavigationBar),
  { loading: () => null, ssr: false }
);

const Verdict = dynamic(
  () => import('./streamer-header/verdict').then((mod) => mod.Verdict),
  { loading: () => null, ssr: false }
);
const Bigwins = dynamic(() => import('./bigwins').then((mod) => mod.Bigwins), {
  loading: () => null,
  ssr: false,
});
const StreamerReviewTableComments = dynamic(
  () =>
    import('./streamer-reviews').then((mod) => mod.StreamerReviewTableComments),
  { loading: () => null, ssr: false }
);
const TabelDescription = dynamic(
  () => import('./streamer-details-table').then((mod) => mod.TabelDescription),
  { loading: () => null, ssr: false }
);
const FAQComponent = dynamic(
  () => import('components/casino-faq').then((mod) => mod.FAQComponent),
  { loading: () => null, ssr: false }
);

const navItems: INavItem[] = [
  {
    icon: <Icon.Like color="white" width={13} height={13} />,
    text: 'Big Wins',
    anchor: `#${Anchor.Bigwins}`,
  },
  {
    icon: <Icon.Comment width={'13'} height={'13'} />,
    text: 'Our Reviews',
    anchor: `#${Anchor.OurReview}`,
  },
  {
    icon: <Icon.Review />,
    text: 'Players Reviews',
    anchor: `#${Anchor.StreamerReviews}`,
  },
  {
    icon: <Icon.Alert />,
    text: 'Details',
    anchor: `#${Anchor.StreamerDetails}`,
  },
  {
    icon: <Icon.Question width={20} height={20} />,
    text: 'FAQ',
    anchor: `#${Anchor.FAQ}`,
  },
];

interface Props {
  streamer: IStreamer;
  reviewGraphResults?: ICasinoReviewGraph[];
  streamerReviews?: IStreamerReview[];
  streamerReviewsCount?: number;
}

export const Streamer = ({
  streamer,
  reviewGraphResults = [],
  streamerReviews = [],
  streamerReviewsCount = 0,
}: Props) => {
  return (
    <>
      <CustomMetadata metadata={allMetadata.streamer(streamer)} />
      <Layout hasFooter isSearchInputMobileVisible>
        <main className={styles.main}>
          <div className={styles.container_s}>
            <Breadcrumbs
              items={[
                ...streamerPage,
                {
                  id: 2,
                  path: `#`,
                  title: streamer?.username ?? '',
                },
              ]}
            />
            <StreamerHeader data={streamer} />

            <Description
              isStreamer
              className={styles.description}
              data={streamer}
            />
            <div className={styles.navigation}>
              <NavigationBarSection
                items={navItems}
                navItemClassName={styles.navItem}
                variantBg="notransparent"
                variantPadding="big"
              />
            </div>
            <Bigwins streamer={streamer} />
            {streamer?.verdict && (
              <Verdict
                title="Our verdict"
                reviewLinkText=""
                description={streamer?.verdict}
              />
            )}
            <StreamerReviewTableComments
              streamer={streamer}
              initialGraphResults={reviewGraphResults}
              initialReviews={streamerReviews}
              initialReviewsCount={streamerReviewsCount}
            />
            <TabelDescription data={streamer} />
            <FAQComponent
              customFaq={streamer.faq}
              titleClassName={styles.title}
            />
          </div>
        </main>
      </Layout>
    </>
  );
};
